export default __webpack_public_path__ + "static/media/expand-arrows.6f1a63bf.svg";